import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import "./Step3.css";

function Step3({ next, back, setAnnualIntake, annualIntake }) {
  const [selectedOption, setSelectedOption] = useState("");

  const radioOptions = ["Less than 100", "100 - 300", "300 - 800", "800+"];

  const handleSelect = (label) => {
    setSelectedOption(label);
    setAnnualIntake(label);
  };

  return (
    <div className="step3_main">
      <h2 className="step_title">
        Just Answer <span>5</span> Simple questions to become a <br />
        <strong>Profcyma Partner</strong>
      </h2>

      <p className="step_subtitle">
        What is the estimated annual intake of new students?
      </p>

      <div className="form_holder">
        <div className="list_holder">
          {radioOptions.map((label, index) => (
            <label
              key={index}
              className={`option_box ${
                annualIntake === label ? "active" : ""
              }`}
              onClick={() => handleSelect(label)}
            >
              {label}

              <Form.Check
                type="radio"
                name="seg"
                className="option_radio"
                value={label}
                checked={annualIntake === label}
                onChange={() => handleSelect(label)}
              />
            </label>
          ))}
        </div>
      </div>

      <div className="step_btns">
        <button onClick={back} className="back_btn">
          Back
        </button>
        <button onClick={next} className="next_btn">
          Next
        </button>
      </div>
    </div>
  );
}

export default Step3;
